import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Radar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import useStyles from "./styles";
import { Typography } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";

// Register required components
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const dotColor = (group) => {
  switch (group) {
    case "Employee":
      return ["rgb(0, 123, 255,1)", "rgb(0, 123, 255,0.5)"];
    case "Investor":
      return ["rgb(170,237,186,1)", "rgb(170,237,186,0.5)"];
    case "Business partner":
      return ["rgb(220, 53, 69, 1)", "rgb(220, 53, 69, 0.5)"];
    case "NGO":
      return ["rgb(236, 112, 193, 1)", "rgb(236, 112, 193, 0.5)"];
    case "Customer":
      return ["rgb(163, 182, 53, 1)", "rgb(163, 182, 53, 0.5)"];
    default:
      return ["rgb(108, 117, 125, 1)", "rgb(108, 117, 125, 0.5)"];
  }
};

const SpiderChart = () => {
  const spiderGraphSelect = useSelector(
    (state) => state.materiality.materialitySpiderGraph
  );
  const classes = useStyles();

  const spiderStatus = spiderGraphSelect.status;
  const spiderData = spiderGraphSelect.data?.spider_chart || {};
  const labelData = spiderGraphSelect.data?.label;
  const spiderInsights = spiderGraphSelect.data?.insights || {};
  const [data, setData] = useState({ labels: [], datasets: [] });

  const options = {
    scales: {
      r: {
        min: 0,
        max: 5,
        ticks: {
          stepSize: 1,
          callback: (value) => value, // ensures all values shown
          color: "#444",
          backdropColor: "transparent",
        },
        grid: {
          circular: true,
          color: "#ccc",
        },
        angleLines: {
          color: "#aaa",
        },
        pointLabels: {
          font: {
            size: 12,
          },
          color: "#222",
        },
      },
    },
    plugins: {
      legend: {
        position: "top", // top of chart area
        align: "end", // aligns to the right side
        labels: {
          boxWidth: 12,
          padding: 10,
        },
        display: true,
        fullSize: true,
      },
    },
    layout: {
      padding: {
        top: 20,
        right: 30,
      },
    },
  };

  useEffect(() => {
    setData({
      labels: labelData,
      datasets: Object.keys(spiderData)?.map((key) => ({
        label: key,
        data: spiderData[key],
        backgroundColor: dotColor(key)[1],
        borderColor: dotColor(key)[0],
        pointBackgroundColor: dotColor(key)[0],
      })),
    });
  }, [spiderData]);

  return (
    <>
      {spiderData && Object.keys(spiderData).length ? (
        <>
          <div className={classes.spiderMain}>
            <div style={{ maxWidth: 900, margin: "0 auto" }}>
              <Radar data={data} options={options} />
            </div>
          </div>
          <div className={classes.zigZagCommonSuggestion}>
            <Typography className={classes.headings} variant="h6">
              Spider Chart Key Insights & Recommendations
            </Typography>
            {Object.keys(spiderInsights)?.map((head) => {
              return (
                <div>
                  <div className={classes.dispDiv}>
                    <CircleIcon
                      style={{
                        width: "10px",
                        height: "10px",
                        marginRight: "10px",
                      }}
                    />
                    <Typography className={classes.mainContentText}>
                      {head
                        .split("_")
                        .map((word, index) =>
                          index === 0
                            ? word.charAt(0).toUpperCase() + word.slice(1)
                            : word
                        )
                        .join(" ")}
                    </Typography>
                  </div>
                  <div style={{ paddingLeft: "20px" }}>
                    <Typography className={classes.mainContentText}>
                      {spiderInsights[head]?.["description"]}
                    </Typography>
                    <Typography className={classes.mainContentText}>
                      Suggestions
                    </Typography>
                    {spiderInsights[head]?.["suggestions"] && (
                      <Typography>
                        {spiderInsights[head]?.["suggestions"]}
                      </Typography>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div className={classes.zMain}>
          <Typography className={classes.headings} variant="h6">
            Spider Graph Data is not available
          </Typography>
        </div>
      )}
    </>
  );
};

export default SpiderChart;
